import Vue from 'vue'
import App from './App.vue'
import './styles/global.css'; // 引入全局样式文件

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 引入 Element UI 样式
Vue.use(ElementUI);


Vue.config.productionTip = false


new Vue({
  render: h => h(App),
}).$mount('#app')
